module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#cinema",
      toString: function () {
        return this.url;
      }
    }